import { useProductImages } from '../hooks/useProductImages';

type CarouselGaleryThumbsProps = { children: React.ReactNode };

const CarouselGaleryThumbs = ({ children }: CarouselGaleryThumbsProps) => {
	const { blockClass, thumbnailsOrientation } = useProductImages();

	const renderClass = () => {
		return blockClass && `vtex-store-components-3-x-carouselGaleryThumbs--${blockClass}`;
	};

	const renderTokens = () => {
		if (thumbnailsOrientation === 'horizontal') {
			return 'dn h-auto mt3 db-ns';
		}

		return 'dn h-auto w-20 bottom-0 top-0 absolute left-0 db-ns';
	};

	return (
		<div
			className={`carouselGaleryThumbs carouselGaleryThumbs--${blockClass} vtex-store-components-3-x-carouselGaleryThumbs ${renderClass()} ${renderTokens()}`}
		>
			{children}
		</div>
	);
};

export default CarouselGaleryThumbs;
